import { Paper, PaperProps, Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { HTMLMotionProps } from "motion/react";
import { forwardRef } from "react";

export interface IGlassProps
  extends
    PaperProps,
    Pick<HTMLMotionProps<any>, "exit" | "initial" | "animate" | "transition"> {
  blur?: number;
  square?: boolean;
  noborder?: boolean;
  noShadow?: boolean;
  height?: string | number;
  boxShadowOpactity?: number;
  noBackground?: boolean;
  // backgroundColor?: string;
  overflow?: string;
}

const useGlassStyles = makeStyles<Theme, IGlassProps>((theme) => ({
  glass: (props) => ({
    // boxShadow: props.noShadow
    //   ? "inherit"
    //   : `10px 10px 22px rgb(196 202 230 / ${props.boxShadowOpactity}%)`,
    backgroundColor: props.noBackground
      ? "transparent"
      : `rgba(255, 255, 255, 0.9)`,
    // backdropFilter: `blur(${props.blur}px)`, causing performance issues
    border: props.noborder ? "none" : `1px solid  rgba(255, 255, 255, 1)`,
    borderRadius: props.square ? 0 : theme.shape.borderRadius,
    height: props.height,
    overflowY: props.overflow ? props.overflow : ("auto" as any),
    overflowX: props.overflow ? props.overflow : ("hidden" as any),
    maxHeight: "100%",
  }),
}));

export const Glass = forwardRef<HTMLDivElement, IGlassProps>(
  (
    {
      blur,
      noborder,
      noShadow,
      elevation = 0,
      height = "100%",
      boxShadowOpactity = "40%",
      noBackground,
      overflow,
      ...props
    },
    ref,
  ) => {
    const { glass } = useGlassStyles({
      blur: blur || 6,
      noborder,
      noShadow,
      height,
      overflow,
      noBackground,
      ...props,
    });
    let classNames = [props.className, glass].join(" ");

    return (
      <Paper ref={ref} elevation={elevation} {...props} className={classNames}>
        {props.children}
      </Paper>
    );
  },
);
